import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
   },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    ClientName: {
      validations: []
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    AddressLine1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    City: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    State: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Postal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    StartTime: {
      validations: []
    },
    EventExtra1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    },
    Notes: {
      validations: []
    },
    Reference: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'FirstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Client Name',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Street Address *',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City *',
            mapping: 'City'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State *',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip *',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Interest *',
            options: [
              { label: 'Group Rates' , value: 'Group Rates'},
              { label: 'Scout Information', value: 'Scout Information'},
              { label: 'Partner Discount Program', value: 'Partner Discount Program'},
              { label: 'Picnic', value: 'Picnic' },
              { label: 'Holiday Party', value: 'Holiday Party' },
              { label: 'After Hours Event', value: 'After Hours Event' },
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Photo Shoot', value: 'Photo Shoot' },
              { label: 'Public Speaker', value: 'Public Speaker' },
              { label: 'Birthday Party', value: 'Birthday Party' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'Theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Requested Date *',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: ' Requested Time',
            options: [
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM (next day)', value: '00:00:00' },
              { label: '12:30 AM (next day)', value: '00:30:00' },
              { label: '1:00 AM (next day)', value: '01:00:00' },
              { label: '1:30 AM (next day)', value: '01:30:00' },
              { label: '2:00 AM (next day)', value: '02:00:00' },
              { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'StartTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Budget *',
            mapping: 'EventExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Planned Number of Guests',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any additional details/questions about your event?',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us? *',
            options: [
              {label: 'Web Search' , value: 'Web Search'},
              {label: 'Facebook' , value: 'Facebook'},
              {label: 'LinkedIn' , value: 'LinkedIn'},
              {label: 'Twitter' , value: 'Twitter'},
              {label: 'Instagram' , value: 'Instagram'},
              {label: 'Word of Mouth' , value: 'Word of Mouth'},
              {label: 'Referral' , value: 'Referral'},
              {label: 'Past Client' , value: 'Past Client'},
              {label: 'Event Planning Website' , value: 'Event Planning Website'},
              {label: 'Other' , value: 'Other'},
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'San Antonio Zoo Contact Form',
    formId: '1857',
    clientKey: '92F18069-54AC-4D6C-BF5A-446AC4787781',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
